import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CourseProvider } from './context/CourseContext';
import { ProgressProvider } from './context/ProgressContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Courses from './pages/Courses';
import CoursePage from './pages/CoursePage';
import CourseDetail from './pages/CourseDetail';
import Community from './pages/Community';
import Resources from './pages/Resources';
import About from './pages/About';
import Contact from './pages/Contact';
import AuthExample from './pages/AuthExample';
import ProtectedRoute from './components/auth/ProtectedRoute';
export function App() {
  return <AuthProvider data-id="element-0">
      <CourseProvider data-id="element-1">
        <ProgressProvider data-id="element-2">
          <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-3">
            <Navbar data-id="element-4" />
            <main className="flex-grow" data-id="element-5">
              <Routes data-id="element-6">
                <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
                <Route path="/login" element={<Login data-id="element-10" />} data-id="element-9" />
                <Route path="/signup" element={<Signup data-id="element-12" />} data-id="element-11" />
                <Route path="/courses" element={<Courses data-id="element-14" />} data-id="element-13" />
                <Route path="/courses/:courseId" element={<ProtectedRoute data-id="element-16">
                      <CoursePage data-id="element-17" />
                    </ProtectedRoute>} data-id="element-15" />
                <Route path="/course-detail/:courseId" element={<ProtectedRoute data-id="element-19">
                      <CourseDetail data-id="element-20" />
                    </ProtectedRoute>} data-id="element-18" />
                <Route path="/community" element={<ProtectedRoute data-id="element-22">
                      <Community data-id="element-23" />
                    </ProtectedRoute>} data-id="element-21" />
                <Route path="/resources" element={<Resources data-id="element-25" />} data-id="element-24" />
                <Route path="/about" element={<About data-id="element-27" />} data-id="element-26" />
                <Route path="/contact" element={<Contact data-id="element-29" />} data-id="element-28" />
                <Route path="/auth-example" element={<AuthExample data-id="element-31" />} data-id="element-30" />
                <Route path="*" element={<Navigate to="/" replace data-id="element-33" />} data-id="element-32" />
              </Routes>
            </main>
            <Footer data-id="element-34" />
          </div>
        </ProgressProvider>
      </CourseProvider>
    </AuthProvider>;
}